import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { hasMany } from 'ember-data/relationships';
import CampaignModel from './campaign';
import NewsletterModel from './newsletter';
import SegmentModel from './segment';
import TransactionalMessageModel from './transactional-message';

export default class TagModel extends Model {
  @attr('string') name!: string;
  @attr('number') apiTriggeredUsed!: number;
  @attr('number') campaignsUsed!: number;
  @attr('number') newslettersUsed!: number;
  @attr('number') segmentsUsed!: number;
  @attr('number') transactionalMessagesUsed!: number;

  @hasMany('campaign', { async: false, inverse: 'tags' }) campaigns!: CampaignModel;
  @hasMany('segment', { async: false, inverse: 'tags' }) segments!: SegmentModel;
  @hasMany('newsletter', { async: false, inverse: 'tags' }) newsletters!: NewsletterModel;
  @hasMany('transactional-message', { async: false, inverse: 'tags' })
  transactionalMessages!: TransactionalMessageModel;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    tag: TagModel;
  }
}
